import _ from 'lodash'
import { CollapseUnion } from '@feedyou/utils'

import { Tariff } from './types.tariff'
import { omitUndefined } from '../../lib/object/object'
import { featuresSchema } from './featuresSchema'
import { FeatureName, FeatureTypeAsString, FeatureValue, FeatureValues } from './types'

function getFeatureValueForTariff(
  featureName: FeatureName,
  tariff: Tariff
): FeatureValue<FeatureName> {
  type CollapsedSchemaItem = CollapseUnion<typeof featuresSchema[FeatureName]>
  return (featuresSchema[featureName] as CollapsedSchemaItem).defaultsPerTariff?.[tariff]
}

function getFeaturesForTariff(tariff: Tariff) {
  return _.mapValues(
    featuresSchema, // I <3 PRETTIER
    (_, featureName: FeatureName) => getFeatureValueForTariff(featureName, tariff)
  )
}

export function getTariffFeatures(tariff: Tariff = window.TARIFF): FeatureValues {
  return omitUndefined(getFeaturesForTariff(tariff))
}

export function getFeatureType(name: FeatureName): FeatureTypeAsString {
  return featuresSchema[name]?.type
}

export function getFeatureNames(): FeatureName[] {
  return Object.keys(featuresSchema) as FeatureName[]
}

export function isSupportedFeature(key: string): key is FeatureName {
  return getFeatureNames().includes(key as any)
}
